import React from 'react';
import './ToggleSwitch.css'; // Import the CSS file for styling

function ToggleSwitch({ isOn, handleToggle, label }) {
  return (
    <div className="toggle-switch-container">
      {label && <span className="toggle-switch-label">{label}</span>}
      <div
        className={`toggle-switch ${isOn ? 'toggle-switch-on' : 'toggle-switch-off'}`}
        onClick={handleToggle}
      >
        <div className="toggle-switch-thumb"></div>
      </div>
    </div>
  );
}

export default ToggleSwitch;